import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

import { Provider } from 'react-redux';
import store from "./redux/store";
import { attachAxiosErrorLogger } from "@/services/apiErrorLogger";

import "./locales/i18n";

attachAxiosErrorLogger(axios, 'global-axios');

console.reportErrorsAsExceptions = false;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <Provider store={store}>
        <App />
    </Provider>

);
